import React from "react";
import { cn } from "@/lib/utils";

// Compact metric tile used across dashboards
export const StatCard = ({ label, value, icon: Icon, tone = "default", onClick, hint }) => {
  const tones = {
    default: "text-foreground",
    brand: "text-brand",
    success: "text-success",
    warning: "text-warning",
    danger: "text-destructive",
  };
  const iconTones = {
    default: "bg-secondary text-secondary-foreground",
    brand: "bg-brand/10 text-brand",
    success: "bg-success/10 text-success",
    warning: "bg-warning/10 text-warning",
    danger: "bg-destructive/10 text-destructive",
  };
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      onClick={onClick}
      className={cn(
        "flex w-full flex-col gap-2 rounded-xl border border-border bg-card p-3.5 text-left shadow-card transition-shadow sm:p-4",
        onClick && "hover:shadow-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-muted-foreground">{label}</span>
        {Icon && (
          <span className={cn("flex h-8 w-8 items-center justify-center rounded-lg", iconTones[tone])}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className={cn("text-2xl font-bold tnum font-display", tones[tone])}>{value}</div>
      {hint && <div className="text-[11px] text-muted-foreground">{hint}</div>}
    </Comp>
  );
};
